/**
 * Представляет высокоуровневую оболочку над Leaflet API
 */
var LeafletMap = (function () {

  function LeafletMap(map) {
    this.map = map;
    this.popupPane = map.getPane('popupPane');
    this.overlayPane = map.getPane('overlayPane');
    //$(this.popupPane).append('<svg width=4000 height=3000>');
    //L.SvgScaleOverlay({ pane: 'popupPane' });
    this.map.addLayer(L.SvgScaleOverlay({ pane: 'popupPane' }));
    this.map.addLayer(L.SvgScaleOverlay({ pane: 'tilePane' }));


    var latlngs = [
      [50.57626025689928, 77.72827148437501],
      [54.50832650029076, 87.38525390625001]
    ];

    this.latlngs = latlngs;

    var points = latlngs.map(function (x) { return map.latLngToLayerPoint(x); });
    var bounds = L.bounds(points);
    var size = bounds.getSize();

    this.bounds = bounds;
    this.size = size;


    //L.rectangle(latlngs,
    //{
    //  color: "#0066cc",
    //  weight: 5,
    //  fill: false,
    //  lineCap: 'butt'
    //}).addTo(this.map);


    this.image = new Image();
    this.image.onload = function () {
      console.log('this.image.onload');
    }
    this.image.src = '/Content/img/general-report-map.png';

    var svg = $(this.map.getPane('tilePane')).find('svg g:first-child');
    svg.append(SvgHelper.create('image', {
      'xlink:href': '/Content/img/general-report-map.png',
      x: bounds.min.x,
      y: bounds.min.y,
      height: size.y,
      width: size.x
      //style: 'transform:scale(' + size + ')'
    }));
  };

  LeafletMap.prototype.setZoom = function (zoom) {
    this.map.setZoom(zoom);
  };


  /**
   * Нарисует на карте balloon
   * 
   * @public
   * @param {LatLng} location Точка на карте, на которую указывает balloon
   * @param {LatLng} position Точка на карте, от которой начнется отрисовка balloon
   * @param {string} content Содержимое balloon в виде HTML
   * @param {Object} params Дополнительные параметры для отрисовки balloon: цвет, шрифт и т.д. (пока неспецифицирован)
   */
  LeafletMap.prototype.addBalloon = function (location, position, content, params) {

    //преобразуем географические координаты, в координаты слоя
    var loc = this.map.latLngToLayerPoint(location);
    var pos = this.map.latLngToLayerPoint(position);

    var popup = L.DomUtil.create('div', 'leaflet-balloon', this.popupPane);
    L.DomUtil.setPosition(popup, pos);

    var $popup = $(popup);
    $popup.html(content);

    var path = SvgHelper.create('path', { 'fill': '#ffffcc', 'stroke': '#ffff66', 'stroke-width': 1 });
    $(this.overlayPane).find('svg').append(path);

    L.DomEvent.disableClickPropagation(popup);
    var draggable = new L.Draggable(popup);
    draggable.enable();
    draggable.on('drag', function (e) {

      var w = $popup.width();
      var h = $popup.height();
      var t = $popup.position().top;
      var l = $popup.position().left;

      var a = t + h / 2;
      var b = l + w / 2;

      $(path).attr('d', ['M', l, a, 'Q', b, a, loc.x, loc.y, 'Q', b, a, l + w, a].join(' '));
    });
  };

  /**
   * Нарисует на карте balloon
   * 
   * @public
   * @param {LatLng} location Точка на карте, на которую указывает balloon
   * @param {LatLng} position Точка на карте, от которой начнется отрисовка balloon
   * @param {string} content Содержимое balloon в виде HTML
   * @param {Object} params Дополнительные параметры для отрисовки balloon: цвет, шрифт и т.д. (пока неспецифицирован)
   */
  LeafletMap.prototype.addBalloon2 = function (location, position, content, params) {

    var svg = $(this.popupPane).find('svg g:first-child');

    var text = SvgHelper.create('text', { y: 5, 'font-size': 16 });

    content.split('<br/>').forEach(function (line) {
      text.appendChild(SvgHelper.create('tspan', { x: 10, dy: '1.25em' }, line));
    });

    //преобразуем географические координаты, в координаты слоя
    var loc = this.map.latLngToLayerPoint(location);
    var pos = this.map.latLngToLayerPoint(position);


    var path = SvgHelper.create('path', { 'fill': '#ffffcc', 'stroke': '#ffff66', 'stroke-width': 1 });
    svg.append(path);

    var popup = SvgHelper.create('g', { 'class': 'leaflet-balloon' });
    popup.appendChild(text);
    svg.append(popup);
    console.log(popup.getBBox());
    popup.prepend(SvgHelper.create('rect', { x: 0, y: 0, width: popup.getBBox().width + 20, height: popup.getBBox().height + 20, style: 'fill:#ffffcc' }));

    
    L.DomUtil.setPosition(popup, pos);
    L.DomEvent.disableClickPropagation(popup);
    
    var draggable = new L.Draggable(popup);
    draggable.enable();
    draggable.on('drag', function (e) {

      var w = popup.getBBox().width;
      var h = popup.getBBox().height;

      var t = L.DomUtil.getPosition(popup).y;
      var l = L.DomUtil.getPosition(popup).x;

      var a = t + h / 2;
      var b = l + w / 2;

      $(path).attr('d', ['M', l, a, 'Q', b, a, loc.x, loc.y, 'Q', b, a, l + w, a].join(' '));
    });
  };

  LeafletMap.prototype.add = function (object) {
    object.addTo(this.map);
  };

  /**
   * Генерирует изображение из карты
   */
  LeafletMap.prototype.exportToBase64 = function() {

    function getTranslate3d(translate3d) {
      var xyz = translate3d.replace("translate3d(", "").replace(")", "").replace(/px/g, '').split(",");
      return {
        x: parseFloat(xyz[0]),
        y: parseFloat(xyz[1]),
        z: parseFloat(xyz[2])
      };
    };

    var self = this;
    var map = this.map;
    var size = { width: this.size.x, height: this.size.y };

    var points = this.latlngs.map(function (x) { return map.latLngToLayerPoint(x); });
    var bounds = L.bounds(points);

    console.log(size);
    console.log(bounds);
    //map.setZoom(9);


    $('#map').width(size.width).height(size.height);

    return new Promise(function(resolve, reject) {

      var canvas = document.createElement('canvas');
      canvas.width = size.width;
      canvas.height = size.height;

      var ctx = canvas.getContext('2d');

      ctx.drawImage(self.image, 0, 0, canvas.width, canvas.height);

      //ctx.scale(2, 2);
      ctx.translate(-self.bounds.min.x, -self.bounds.min.y);

      var svgLayers = [
        $(map.getPane('tilePane')).find('svg')[0],
        $(map.getPane('overlayPane')).find('svg')[0],
        $(map.getPane('popupPane')).find('svg')[0]
      ];
      svgLayers.forEach(function(svg) {

        //var viewBox = svg.viewBox.baseVal;
        //var mapPaneTranslate3d = getTranslate3d(map.getContainer().querySelector('.leaflet-map-pane').style['transform']);
        
        var svgText = new XMLSerializer().serializeToString(svg);
        ctx.drawSvg(svgText, 0, 0, svg.width.baseVal.value, svg.height.baseVal.value);
      });

      var center = map.getCenter();

      $('[js=download]')[0].href = canvas.toDataURL();

      //resolve(canvas.toDataURL());
    });


    //LeafletMap.prototype.exportToBase64 = function() {

    //  function getTranslate3d(translate3d) {
    //    var xyz = translate3d.replace("translate3d(", "").replace(")", "").replace(/px/g, '').split(",");
    //    return {
    //      x: parseFloat(xyz[0]),
    //      y: parseFloat(xyz[1]),
    //      z: parseFloat(xyz[2])
    //    };
    //  };

    //  var map = this.map;

    //  return new Promise(function(resolve, reject) {
    //    leafletImage(map, function (err, canvas) {

    //      var size = map.getSize();

    //      var map_c = map.getContainer();
    //      var svg = map_c.querySelector('svg');
    //      var dimensions = map.getSize();

    //      if (svg) {
    //        var viewBoxData = svg.attributes.viewBox.value.split(' ');
    //        var viewBox = {
    //          x: parseInt(viewBoxData[0]),
    //          y: parseInt(viewBoxData[1]),
    //          width: parseInt(viewBoxData[2]),
    //          height: parseInt(viewBoxData[3])
    //        };

    //        var ctx = canvas.getContext('2d');
    //        var mapPaneTranslate3d = getTranslate3d(map_c.querySelector('.leaflet-map-pane').style['transform']);

    //        console.log(mapPaneTranslate3d);
    //        ctx.translate(mapPaneTranslate3d.x, mapPaneTranslate3d.y);

    //        var svgText = new XMLSerializer().serializeToString(svg);
    //        ctx.drawSvg(svgText, viewBox.x, viewBox.y, viewBox.width, viewBox.height);
    //      }


    //      var popupPane = map.getPane('popupPane');
    //      //popupPane.style.transform = "translate3d(0px,0px,0px)";
    //      popupPane.style.width = size.x + "px";
    //      popupPane.style.height = size.y + "px";

    //      $(popupPane).find('.test-popup').each(function () {
    //        //var mapTransform = this.style.transform.replace("translate3d(", "").split(",");
    //        //var x = parseFloat(mapTransform[0].replace("px", ""));
    //        //var y = parseFloat(mapTransform[1].replace("px", ""));
    //        //this.style.transform = "translate3d(0px, 0px, 0px)";
    //      });


    //      html2canvas(popupPane, {
    //        canvas: canvas,
    //        onrendered: function () {
    //          resolve(canvas.toDataURL());
    //        }
    //      });


    //      //console.log(canvas.toDataURL());
    //      //var img = document.getElementById('result');
    //      //var dimensions = map.getSize();
    //      //img.width = dimensions.x;
    //      //img.height = dimensions.y;
    //      //img.src = canvas.toDataURL();
    //    });
    //  });
  };

  return LeafletMap;
}());
